// extracted by mini-css-extract-plugin
export default {"overlayModal":"QmasDocumentCell_overlayModal__BdSI0"};